import axiosInstance from "@/api/axios-instance";

export type BulkInviteOutcome = "invited" | "skipped" | "failed";

export interface BulkInviteResult {
  professional_id: string;
  name: string | null;
  email: string | null;
  outcome: BulkInviteOutcome;
  reason?: string;
}

export interface BulkInviteResponse {
  requested: number;
  invited: number;
  skipped: number;
  failed: number;
  results: BulkInviteResult[];
}

/**
 * Invites several professionals to the dashboard in one request.
 *
 * Always resolves with a per-person breakdown rather than throwing on the first
 * refusal — partial success is the normal outcome, and an admin needs to know
 * WHICH of sixty people to chase. The server re-checks eligibility against live
 * rows, so ids from a stale list are reported as skipped rather than trusted.
 *
 * The request is slow by design: invitations go to Clerk one at a time so a
 * large selection cannot trip rate limits.
 */
export async function inviteProfessionalsBulk(professionalIds: string[]) {
  const response = await axiosInstance.post<BulkInviteResponse>(
    "/professional/invite/bulk",
    { professional_ids: professionalIds }
  );
  return response.data;
}
